import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  buyButton: {
    id: 'modules.BuyGiftCards.buyButton',
    defaultMessage: 'Complete purchase, '
  },
  orPayWith: {
    id: 'modules.BuyGiftCards.orPayWith',
    defaultMessage: 'or pay with'
  },
  useTheSameEmail: {
    id: 'modules.BuyGiftCards.useSameEmail',
    defaultMessage: 'Use the same email for a receipt as for a voucher.'
  },
  applyDiscountCodeRestriction: {
    id: 'modules.BuyGiftCards.applyDiscountCodeRestriction',
    defaultMessage: 'You can apply discount code only for 1 gift card per order'
  }
});
